#Sends a request to change the state of the left bar in session data.
window.postLeftBarState = (state)->
  $.ajax '/toggle_left_bar',
    type: "POST"
    dataType: "json"
    data: {"left_bar_state":state}
$(document).on "turbolinks:load", ->
  ToggleTooltips()
  #If the left bar is empty, then we shouldn't add any of the collapsing functionality
  if $("#leftbar-inner").children().length != 0
    #This will setup the page if the previous state of the left bar was collapsed.
#    if localStorage.getItem("left-bar-toggle-state") == "false"
#      $("#center-region").toggleClass("expanded collapsed")
#      $("#collapse-button").toggleClass("expanded collapsed")
#      $("#leftbar-inner").toggleClass("collapsed")
#      $("#collapse-button").attr("src","<%#= asset_path('right_arrow.png')%>")

    #Handles clicking the arrow button
    if $("#collapse-button").data("initialized") == undefined
      $("#collapse-button").on 'click', ->
        $("#collapse-button").toggleClass("expanded collapsed")
        $("#leftbar").toggleClass("expanded collapsed")
        $("#leftbar-inner").toggleClass("expanded collapsed")
        $("#center-region").toggleClass("expanded collapsed")
        $("#left-bar-heading").toggleClass("displayed hidden")

        isExpanded = $("#center-region").hasClass("expanded")
        $("#collapse-button").attr("aria-expanded", isExpanded)
        label = if isExpanded then $("#collapse-button").data("label-expanded") else $("#collapse-button").data("label-collapsed")
        $("#collapse-button").attr("aria-label", label)

        # $("#leftbar-inner").toggleClass("collapsed")

        postLeftBarState(isExpanded)
        #localStorage.setItem("left-bar-toggle-state", $("#center-region").hasClass("expanded"))
        ToggleTooltips()
    $("#collapse-button").data("initialized", true)
  else
    #Keeps the button visible even when collapse functionality isn't available.
    $("#collapse-button").prop("disabled", true).attr("aria-disabled", "true")

ToggleTooltips =  ->
  if $("#center-region").hasClass("expanded")
    $('.sidebar-tooltip[data-bs-toggle="tooltip"]').tooltip('disable');
  else
    $('.sidebar-tooltip[data-bs-toggle="tooltip"]').tooltip('enable');
